/**
 * Загрузка скриптов в зависимости от текущего адреса
 */
function main(): void
{
	const path = window.location.pathname;
	
	switch ( path )
	{
		case '/':
			import ( /* webpackChunkName: "index" */ './Index/index' )
				.then( ( module ) => module.default() );
			break;
		
		case '/buy/':
			import ( /* webpackChunkName: "buy" */ './Buy/index' )
				.then( ( module ) => module.default() );
			break;
		
		case '/commercial/':
			import ( /* webpackChunkName: "contacts" */ './Commercial/index' )
				.then( ( module ) => module.default() );
			break;
		
		case '/contacts/':
			import ( /* webpackChunkName: "contacts" */ './Contacts/index' )
				.then( ( module ) => module.default() );
			break;
		
		case '/decoration/':
			import ( /* webpackChunkName: "decoration" */ './Decoration/index' )
				.then( ( module ) => module.default() );
			break;
		
		case '/documents/':
			import ( /* webpackChunkName: "documents" */ './Documents/index' )
				.then( ( module ) => module.default() );
			break;
		
		case '/news/':
			import ( /* webpackChunkName: "news" */ './News/index' )
				.then( ( module ) => module.default() );
			break;
		
		case '/progress/':
			import ( /* webpackChunkName: "progress" */ './Progress/index' )
				.then( ( module ) => module.default() );
			break;
		
		case '/company/':
			import ( /* webpackChunkName: "company" */ './Company/index' )
				.then( ( module ) => module.default() );
			break;
		
		default:
			if ( /^\/choose\//.test( path ) )
			{
				import ( /* webpackChunkName: "choose" */ './Choose/index' )
					.then( ( module ) => module.default() );
			}
			break;
	}
}

/**
 * Module
 */
export {
	main as default,
};



// WEBPACK FOOTER //
// ./app/Routes/index.ts